import classes from './Banner.module.scss';
import Button from "../../GlobalComponents/Button/Button";
import { useTranslation } from 'react-i18next';

const Banner = () => {
    const { t } = useTranslation();
    return (
        <section className="container">
            <div className={classes.banner}>
                <div className={classes.content}>
                    <h1 className={`${classes.title} font-48`}>
                        {t('services.banner.title')}
                    </h1>
                    <div className={`${classes.text} font-16`}>
                        <p>
                            {t('services.banner.text_01')}
                        </p>
                        <p>
                            {t('services.banner.text_02')}
                        </p>
                        <p>
                            {t('services.banner.text_03')}
                        </p>
                    </div>
                    <div className={classes.btn}>
                        <Button form>
                            {t('btn.consultation')}
                        </Button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Banner;
